const translation = {
  custom: 'Personalizare',
  upgradeTip: {
    prefix: 'Actualizați-vă planul pentru a',
    suffix: 'să vă personalizați marca.',
  },
  webapp: {
    title: 'Personalizați marca WebApp',
    removeBrand: 'Eliminați "Powered by Dify"',
    changeLogo: 'Schimbați imaginea mărcii "Powered by"',
    changeLogoTip: 'Format SVG sau PNG cu o dimensiune minimă de 40x40px',
  },
  app: {
    title: 'Personalizați marca antetului aplicației',
    changeLogoTip: 'Format SVG sau PNG cu o dimensiune minimă de 80x80px',
  },
  upload: 'Încărcare',
  uploading: 'Se încarcă',
  uploadedFail: 'Încărcarea imaginii a eșuat, vă rugăm să o reîncărcați.',
  change: 'Schimbă',
  apply: 'Aplică',
  restore: 'Restabilește valorile implicite',
  customize: {
    contactUs: ' contactați-ne ',
    prefix: 'Pentru a personaliza sigla mărcii în cadrul aplicației, vă rugăm',
    suffix: 'să actualizați la ediția Enterprise.',
  },
}

export default translation
